import { Component } from '@angular/core';
import { OrderDetailItemsComponent } from '@spartacus/order/components';
import { Observable } from 'rxjs';

@Component({
  selector: 'cx-order-details-items',
  templateUrl: './custom-order-detail-items.component.html',
  standalone: false
})
export class CustomOrderDetailItemsComponent extends OrderDetailItemsComponent {
  order$: Observable<any>;
}
